import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { BlockNoteView } from '@blocknote/mantine';
import { useCreateBlockNote } from '@blocknote/react';
import * as Y from 'yjs';
import { WebsocketProvider } from 'y-websocket';

// API configuration
const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:8788';
const REALTIME_URL = import.meta.env.VITE_REALTIME_URL || 'ws://localhost:8789';

export function Editor() {
  const { pageId } = useParams<{ pageId: string }>();
  const [title, setTitle] = useState('Untitled');
  const [ydoc] = useState(() => new Y.Doc());
  const [provider, setProvider] = useState<WebsocketProvider | null>(null);

  // Create BlockNote editor with Yjs collaboration
  const editor = useCreateBlockNote({
    collaboration: {
      provider: provider || undefined,
      fragment: ydoc.getXmlFragment('document'),
      user: {
        name: 'Anonymous',
        color: '#' + Math.floor(Math.random() * 16777215).toString(16),
      },
    },
  });

  useEffect(() => {
    if (!pageId) return;

    // Connect to realtime sync
    const wsProvider = new WebsocketProvider(
      `${REALTIME_URL}/sync`,
      pageId,
      ydoc
    );

    setProvider(wsProvider);

    // Load page metadata
    fetch(`${API_URL}/v1/pages/${pageId}`, {
      headers: {
        'Authorization': `Bearer beb0nd-d3v-auth-s3cr3t-2026`,
      },
    })
      .then((res) => res.json())
      .then((data) => {
        if (data.page?.title) {
          setTitle(data.page.title);
        }
      })
      .catch(console.error);

    return () => {
      wsProvider.destroy();
    };
  }, [pageId, ydoc]);

  const handleTitleChange = async (newTitle: string) => {
    setTitle(newTitle);

    // Save title to API
    await fetch(`${API_URL}/v1/pages/${pageId}`, {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer beb0nd-d3v-auth-s3cr3t-2026`,
      },
      body: JSON.stringify({ title: newTitle }),
    });
  };

  return (
    <div className="editor-container">
      <input
        type="text"
        value={title}
        onChange={(e) => handleTitleChange(e.target.value)}
        className="page-title-input"
        placeholder="Untitled"
      />
      <div className="blocknote-wrapper">
        <BlockNoteView editor={editor} theme="light" />
      </div>
    </div>
  );
}
